const PATH_CHUNK_DIVIDER = '/'
const QUERY_PARAMETERETERS_DIVIDER = '&'

/**
 * Interpolates the given path with the given params.
 * @param  {string} path
 * @param  {Object} [params={}]
 * @returns {string}
 */
function interpolateStringUtil (path, params = {}) {
  const pathChunks = path.split(PATH_CHUNK_DIVIDER)
  // Assert the params have all the pathChunk
  pathChunks.forEach((pathChunk, index) => {
    // If it's not a pathChunk with parameters, noop
    if (!pathChunk.includes(':')) {
      return
    }
    const parametersArr = pathChunk.split(QUERY_PARAMETERETERS_DIVIDER)
    parametersArr.forEach(parameter => {
      const parameterKey = parameter.slice(parameter.indexOf(':') + 1)
      // If the params has the `pathChunk` replace it
      if (Object.hasOwnProperty.call(params, parameterKey)) {
        pathChunks[index] = pathChunks[index].replace(
          `:${parameterKey}`,
          params[parameterKey]
        )
      }
    })
    pathChunk.replace(/:|\?/g, '')
  })
  return pathChunks.join('/')
}

export {
  interpolateStringUtil
}
